import { DateTimeRange } from '@modules/common/components/DateRangePicker/types';
import {
  getAggregatePeriodFromFixedDateRange,
  getAggregatePeriodFromLastDateRange,
  getAggregatePeriodFromSinceDateRange,
} from '.';

export function getAggregatePeriodFromDateRange(dateRange: DateTimeRange) {
  switch (dateRange.type) {
    case 'last':
      return getAggregatePeriodFromLastDateRange(dateRange);
    case 'since':
      return getAggregatePeriodFromSinceDateRange(dateRange);
    default:
      return getAggregatePeriodFromFixedDateRange(dateRange);
  }
}
